var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      ref: "form_step_2",
      model: {
        value: _vm.form,
        callback: function($$v) {
          _vm.form = $$v
        },
        expression: "form"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "mt-5" },
        [
          _c("v-card-title", { staticClass: "grey lighten-4 p-2" }, [
            _c("h4", { staticClass: "m-0" }, [_vm._v("Confirm Reservation")])
          ]),
          _vm._v(" "),
          _c(
            "v-row",
            [
              _c("v-col", [_c("ticket-information")], 1),
              _vm._v(" "),
              _c("v-col", [_c("rental-information")], 1)
            ],
            1
          ),
          _vm._v(" "),
          _vm.notes_on_kiosk ? _c("additional-information") : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("renters-list-table", {
        staticClass: "mt-2",
        attrs: { title: "Renters list", "no-action": true }
      }),
      _vm._v(" "),
      _vm.gateway == "stripe"
        ? [
            !_vm.cost.free_checkout
              ? [
                  (_vm.is_prepay &&
                    (_vm.prepay_payment || _vm.only_save_card_at_prepay)) ||
                  (_vm.is_seasonal &&
                    !_vm.advance_seasonal &&
                    (_vm.full_charge_at_seasonal_kiosk ||
                      _vm.credit_card_swipe_kiosk)) ||
                    (_vm.is_seasonal &&
                      _vm.advance_seasonal &&
                      (_vm.full_charge_at_seasonal_advance_on ||
                        _vm.save_card_at_seasonal_advance_on)) ||
                  (!_vm.is_seasonal &&
                    (_vm.full_charge_at_kiosk || _vm.swipeMode))
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "mt-5" },
                            [
                              !_vm.kiosk_save_only
                                ? _c(
                                    "v-card-title",
                                    { staticClass: "grey lighten-4 p-2" },
                                    [
                                      _c("h4", { staticClass: "m-0" }, [
                                        _c(
                                          "span",
                                          { staticClass: " error--text" },
                                          [_vm._v(" Reservation Total:")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "blue--text text--accent-4"
                                          },
                                          [_vm._v("$" + _vm._s(_vm.amount))]
                                        )
                                      ])
                                    ]
                                  )
                                : _vm.kiosk_save_only && !_vm.fullCharge
                                ? _c(
                                    "v-card-title",
                                    { staticClass: "grey lighten-4 p-2" },
                                    [
                                      _c(
                                        "h5",
                                        {
                                          staticClass:
                                            "m-0 font-weight-bold error--text text-break"
                                        },
                                        [
                                          _vm._v(
                                            "\n                            We are saving your card information and are not charging you at this time\n                        "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "p-2" },
                                [
                                  _vm.reservation.is_seasonal &&
                                  _vm.securitydeposit &&
                                  !_vm.swipeMode &&
                                  _vm.frontend_view_folder ==
                                    "frontend.highcountryskiandtennis"
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "mt-5 error--text  text-break"
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Please Enter Credit Card Information that is used as a security Deposit.\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  ((!_vm.securitydeposit &&
                                    _vm.is_seasonal &&
                                    _vm.frontend_view_folder ==
                                      "frontend.highcountryskiandtennis") ||
                                    !_vm.is_seasonal ||
                                    (_vm.is_seasonal &&
                                      _vm.frontend_view_folder !==
                                        "frontend.highcountryskiandtennis")) &&
                                  _vm.kiosk_save_only
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            class:
                                              _vm.is_seasonal &&
                                              _vm.kiosk_save_only
                                                ? "error--text"
                                                : "mt-5 error--text"
                                          },
                                          [
                                            _vm._v(" Reservation Total: "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "blue--text text--accent-4"
                                              },
                                              [_vm._v("$" + _vm._s(_vm.amount))]
                                            )
                                          ]
                                        )
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.securitydeposit &&
                                  _vm.kiosk_save_only &&
                                  _vm.is_seasonal &&
                                  _vm.frontend_view_folder ==
                                    "frontend.highcountryskiandtennis"
                                    ? [
                                        _c("div", {}, [
                                          _vm._v(" Total Rental: "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "blue--text text--accent-4"
                                            },
                                            [
                                              _vm._v(
                                                "$" +
                                                  _vm._s(
                                                    parseFloat(
                                                      parseFloat(_vm.amount) -
                                                        _vm.cost.deposit_total
                                                    ).toFixed(2)
                                                  )
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "error--text" },
                                          [
                                            _vm._v(" Deposit: "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "blue--text text--accent-4"
                                              },
                                              [
                                                _vm._v(
                                                  "$" +
                                                    _vm._s(
                                                      parseFloat(
                                                        _vm.cost.deposit_total
                                                      ).toFixed(2)
                                                    )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "mb-5 error--text" },
                                          [
                                            _vm._v(" Total: "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "blue--text text--accent-4"
                                              },
                                              [
                                                _vm._v(
                                                  "$" +
                                                    _vm._s(
                                                      parseFloat(
                                                        _vm.amount
                                                      ).toFixed(2)
                                                    )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.cash_pay_switch &&
                                  _vm.reservation.is_from_kiosk == 1 &&
                                    ((_vm.reservation.is_seasonal &&
                                      _vm.seasonal_kiosk_cash_pay) ||
                                      (!_vm.reservation.is_seasonal &&
                                        _vm.kiosk_cash_pay))
                                    ? [
                                        _c(
                                          "span",
                                          { staticClass: "mt-5" },
                                          [
                                            _c("with-validation", {
                                              attrs: {
                                                context: _vm.self(),
                                                field: "kiosk_cash_pay"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(ref) {
                                                      var bind = ref.bind
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          "v-checkbox",
                                                          _vm._g(
                                                            _vm._b(
                                                              {
                                                                attrs: {
                                                                  "true-value": true,
                                                                  "false-value": false
                                                                },
                                                                scopedSlots: _vm._u(
                                                                  [
                                                                    {
                                                                      key:
                                                                        "label",
                                                                      fn: function() {
                                                                        return [
                                                                          _c(
                                                                            "div",
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                                I prefer to pay cash at the register\n                                            "
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      },
                                                                      proxy: true
                                                                    }
                                                                  ],
                                                                  null,
                                                                  true
                                                                )
                                                              },
                                                              "v-checkbox",
                                                              bind,
                                                              false
                                                            ),
                                                            on
                                                          )
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                3891896906
                                              )
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", { attrs: { id: "card-element" } })
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("with-validation", {
                        attrs: { field: "agreement" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var bind = ref.bind
                                var on = ref.on
                                return [
                                  (_vm.is_prepay &&
                                    (_vm.prepay_payment ||
                                      _vm.only_save_card_at_prepay)) ||
                                  (_vm.is_seasonal &&
                                    !_vm.advance_seasonal &&
                                    (_vm.full_charge_at_seasonal_kiosk ||
                                      _vm.credit_card_swipe_kiosk)) ||
                                    (_vm.is_seasonal &&
                                      _vm.advance_seasonal &&
                                      (_vm.full_charge_at_seasonal_advance_on ||
                                        _vm.save_card_at_seasonal_advance_on)) ||
                                  (!_vm.is_seasonal &&
                                    (_vm.full_charge_at_kiosk || _vm.swipeMode))
                                    ? _c(
                                        "v-checkbox",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "label",
                                                    fn: function() {
                                                      return [
                                                        _vm._v(
                                                          "\n                            I have read and agree to the\n                             "
                                                        ),
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: "#"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                $event.preventDefault()
                                                                return _vm.ui__openModalByName(
                                                                  {
                                                                    name:
                                                                      "dialog_terms"
                                                                  }
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.terms_and_conditions_title
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          "\n                            ,\n                             "
                                                        ),
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: "#"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                $event.preventDefault()
                                                                return _vm.ui__openModalByName(
                                                                  {
                                                                    name:
                                                                      "dialog_privacy_policy"
                                                                  }
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.privacy_policy_title
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          " \n                            and\n                             "
                                                        ),
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: "#"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                $event.preventDefault()
                                                                return _vm.ui__openModalByName(
                                                                  {
                                                                    name:
                                                                      "dialog_cancelation_policy"
                                                                  }
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.cancellation_policy_title
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    },
                                                    proxy: true
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            },
                                            "v-checkbox",
                                            bind,
                                            false
                                          ),
                                          on
                                        )
                                      )
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          4235748856
                        )
                      })
                    ],
                    1
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            ((_vm.is_prepay &&
              (_vm.prepay_payment || _vm.only_save_card_at_prepay)) ||
              (_vm.is_seasonal &&
                !_vm.advance_seasonal &&
                (_vm.full_charge_at_seasonal_kiosk ||
                  _vm.credit_card_swipe_kiosk)) ||
              (_vm.is_seasonal &&
                _vm.advance_seasonal &&
                (_vm.full_charge_at_seasonal_advance_on ||
                  _vm.save_card_at_seasonal_advance_on)) ||
              (!_vm.is_seasonal &&
                (_vm.full_charge_at_kiosk || _vm.swipeMode))) &&
            !_vm.cost.free_checkout
              ? [
                  _vm.$store.state.resources.config.google_recaptcha == "1" &&
                  _vm.$store.state.resources.config.google_recaptcha_site_key !=
                    ""
                    ? [
                        _c("div", { staticClass: "mt-5" }, [
                          _c("h6", [
                            _vm._v("This site is protected by Google reCAPTCHA")
                          ])
                        ])
                      ]
                    : _vm._e()
                ]
              : _vm._e(),
            _vm._v(" "),
            [
              _vm.$store.state.resources.config.google_recaptcha == "1" &&
              _vm.$store.state.resources.config.google_recaptcha_site_key != ""
                ? [
                    _c("div", { staticClass: "mt-5" }, [
                      _c("div", { ref: "kiosk_recaptcha" })
                    ])
                  ]
                : _vm._e()
            ],
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-5" },
              [
                _c("errors-alert", { attrs: { errors: _vm.v__getErrors() } }),
                _vm._v(" "),
                typeof _vm.errorMessagesList !== "undefined" &&
                typeof _vm.errorMessagesList === "object" &&
                  _vm.errorMessagesList.length !== 0 &&
                  _vm.v__getErrors().length === 0
                  ? _c("errors-alert", {
                      attrs: { errors: _vm.errorMessagesList }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "secondary",
                      disabled: _vm.$store.state.config.stepLoading
                    },
                    on: {
                      click: function($event) {
                        return _vm.go_back()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                " + _vm._s("Back") + "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      id: "stripe-card-button",
                      color: "primary",
                      loading: _vm.$store.state.config.stepLoading,
                      disabled: _vm.disabled_status
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.payButtonText()) +
                        "\n            "
                    )
                  ]
                )
              ],
              1
            )
          ]
        : !_vm.is_using_square
        ? [
            !_vm.cost.free_checkout
              ? [
                  (_vm.is_prepay &&
                    (_vm.prepay_payment || _vm.only_save_card_at_prepay)) ||
                  (_vm.is_seasonal &&
                    !_vm.advance_seasonal &&
                    (_vm.full_charge_at_seasonal_kiosk ||
                      _vm.credit_card_swipe_kiosk)) ||
                  (_vm.is_seasonal &&
                    _vm.advance_seasonal &&
                    (_vm.full_charge_at_seasonal_advance_on ||
                      _vm.save_card_at_seasonal_advance_on)) ||
                  (!_vm.is_seasonal &&
                    (_vm.full_charge_at_kiosk || _vm.swipeMode))
                    ? _c("payment-widget", {
                        attrs: {
                          prepay: _vm.is_prepay,
                          amount:
                            (_vm.prepay_payment ||
                              _vm.only_save_card_at_prepay) &&
                            _vm.is_prepay
                              ? parseFloat(_vm.prepay_total_price).toFixed(2)
                              : _vm.cost.amount_to_be_paid,
                          "swipe-mode":
                            (_vm.is_seasonal &&
                              !_vm.advance_seasonal &&
                              _vm.credit_card_swipe_kiosk) ||
                            (_vm.is_seasonal &&
                              _vm.advance_seasonal &&
                              _vm.save_card_at_seasonal_advance_on) ||
                            (!_vm.is_seasonal && _vm.swipeMode),
                          "validation-id": _vm.v__validationId,
                          "reservation-type": "kiosk"
                        }
                      })
                    : _vm._e()
                ]
              : _vm._e(),
            _vm._v(" "),
            ((_vm.is_prepay &&
              (_vm.prepay_payment || _vm.only_save_card_at_prepay)) ||
              (_vm.is_seasonal &&
                !_vm.advance_seasonal &&
                (_vm.full_charge_at_seasonal_kiosk ||
                  _vm.credit_card_swipe_kiosk)) ||
              (_vm.is_seasonal &&
                _vm.advance_seasonal &&
                (_vm.full_charge_at_seasonal_advance_on ||
                  _vm.save_card_at_seasonal_advance_on)) ||
              (!_vm.is_seasonal &&
                (_vm.full_charge_at_kiosk || _vm.swipeMode))) &&
            !_vm.cost.free_checkout
              ? [
                  _vm.$store.state.resources.config.google_recaptcha == "1" &&
                  _vm.$store.state.resources.config.google_recaptcha_site_key !=
                    ""
                    ? [
                        _c("div", { staticClass: "mt-5" }, [
                          _c("h6", [
                            _vm._v("This site is protected by Google reCAPTCHA")
                          ])
                        ])
                      ]
                    : _vm._e()
                ]
              : _vm._e(),
            _vm._v(" "),
            [
              _vm.$store.state.resources.config.google_recaptcha == "1" &&
              _vm.$store.state.resources.config.google_recaptcha_site_key != ""
                ? [
                    _c("div", { staticClass: "mt-5" }, [
                      _c("div", { ref: "kiosk_recaptcha" })
                    ])
                  ]
                : _vm._e()
            ],
            _vm._v(" "),
            _c("steps-navigation", {
              attrs: {
                "error-messages-list": _vm.errorMessagesList,
                errors: _vm.v__getErrors(),
                "next-button":
                  (_vm.is_seasonal &&
                    !_vm.advance_seasonal &&
                    _vm.full_charge_at_seasonal_kiosk) ||
                  (_vm.is_seasonal &&
                    _vm.advance_seasonal &&
                    _vm.full_charge_at_seasonal_advance_on) ||
                  (!_vm.is_seasonal &&
                    _vm.full_charge_at_kiosk &&
                    !_vm.cost.free_checkout)
                    ? "Pay"
                    : "Save"
              },
              on: {
                "step-back": function($event) {
                  return _vm.stepBack({ validate: false, submit: false })
                },
                "step-next": function($event) {
                  return _vm.stepNext({ stay: true })
                }
              }
            })
          ]
        : _vm.is_using_square
        ? [
            !_vm.cost.free_checkout
              ? [
                  (_vm.is_prepay &&
                    (_vm.prepay_payment || _vm.only_save_card_at_prepay)) ||
                  (_vm.is_seasonal &&
                    !_vm.advance_seasonal &&
                    (_vm.full_charge_at_seasonal_kiosk ||
                      _vm.credit_card_swipe_kiosk)) ||
                    (_vm.is_seasonal &&
                      _vm.advance_seasonal &&
                      (_vm.full_charge_at_seasonal_advance_on ||
                        _vm.save_card_at_seasonal_advance_on)) ||
                  (!_vm.is_seasonal &&
                    (_vm.full_charge_at_kiosk || _vm.swipeMode))
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "mt-5" },
                            [
                              !_vm.kiosk_save_only
                                ? _c(
                                    "v-card-title",
                                    { staticClass: "grey lighten-4 p-2" },
                                    [
                                      _c("h4", { staticClass: "m-0" }, [
                                        _c(
                                          "span",
                                          { staticClass: " error--text" },
                                          [_vm._v(" Reservation Total:")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "blue--text text--accent-4"
                                          },
                                          [_vm._v("$" + _vm._s(_vm.amount))]
                                        )
                                      ])
                                    ]
                                  )
                                : _vm.kiosk_save_only && !_vm.fullCharge
                                ? _c(
                                    "v-card-title",
                                    { staticClass: "grey lighten-4 p-2" },
                                    [
                                      _c(
                                        "h5",
                                        {
                                          staticClass:
                                            "m-0 font-weight-bold error--text text-break"
                                        },
                                        [
                                          _vm._v(
                                            "\n                        We are saving your card information and are not charging you at this time\n                    "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "p-2" },
                                [
                                  _vm.reservation.is_seasonal &&
                                  _vm.securitydeposit &&
                                  !_vm.swipeMode &&
                                  _vm.frontend_view_folder ==
                                    "frontend.highcountryskiandtennis"
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "mt-5 error--text  text-break"
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Please Enter Credit Card Information that is used as a security Deposit.\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  ((!_vm.securitydeposit &&
                                    _vm.is_seasonal &&
                                    _vm.frontend_view_folder ==
                                      "frontend.highcountryskiandtennis") ||
                                    !_vm.is_seasonal ||
                                    (_vm.is_seasonal &&
                                      _vm.frontend_view_folder !==
                                        "frontend.highcountryskiandtennis")) &&
                                  _vm.kiosk_save_only
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            class:
                                              _vm.is_seasonal &&
                                              _vm.kiosk_save_only
                                                ? "error--text"
                                                : "mt-5 error--text"
                                          },
                                          [
                                            _vm._v(" Reservation Total: "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "blue--text text--accent-4"
                                              },
                                              [_vm._v("$" + _vm._s(_vm.amount))]
                                            )
                                          ]
                                        )
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.securitydeposit &&
                                  _vm.kiosk_save_only &&
                                  _vm.is_seasonal &&
                                  _vm.frontend_view_folder ==
                                    "frontend.highcountryskiandtennis"
                                    ? [
                                        _c("div", {}, [
                                          _vm._v(" Total Rental: "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "blue--text text--accent-4"
                                            },
                                            [
                                              _vm._v(
                                                "$" +
                                                  _vm._s(
                                                    parseFloat(
                                                      parseFloat(_vm.amount) -
                                                        _vm.cost.deposit_total
                                                    ).toFixed(2)
                                                  )
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "error--text" },
                                          [
                                            _vm._v(" Deposit: "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "blue--text text--accent-4"
                                              },
                                              [
                                                _vm._v(
                                                  "$" +
                                                    _vm._s(
                                                      parseFloat(
                                                        _vm.cost.deposit_total
                                                      ).toFixed(2)
                                                    )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "mb-5 error--text" },
                                          [
                                            _vm._v(" Total: "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "blue--text text--accent-4"
                                              },
                                              [
                                                _vm._v(
                                                  "$" +
                                                    _vm._s(
                                                      parseFloat(
                                                        _vm.amount
                                                      ).toFixed(2)
                                                    )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", { attrs: { id: "card-container" } })
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "v-col",
              { attrs: { cols: "12" } },
              [
                _c("with-validation", {
                  attrs: { field: "agreement" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        var bind = ref.bind
                        var on = ref.on
                        return [
                          (_vm.is_prepay &&
                            (_vm.prepay_payment ||
                              _vm.only_save_card_at_prepay)) ||
                          (_vm.is_seasonal &&
                            !_vm.advance_seasonal &&
                            (_vm.full_charge_at_seasonal_kiosk ||
                              _vm.credit_card_swipe_kiosk)) ||
                          (_vm.is_seasonal &&
                            _vm.advance_seasonal &&
                            (_vm.full_charge_at_seasonal_advance_on ||
                              _vm.save_card_at_seasonal_advance_on)) ||
                          (!_vm.is_seasonal &&
                            (_vm.full_charge_at_kiosk || _vm.swipeMode))
                            ? _c(
                                "v-checkbox",
                                _vm._g(
                                  _vm._b(
                                    {
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "label",
                                            fn: function() {
                                              return [
                                                _vm._v(
                                                  "\n                        I have read and agree to the\n                         "
                                                ),
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: { href: "#" },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        $event.preventDefault()
                                                        return _vm.ui__openModalByName(
                                                          {
                                                            name: "dialog_terms"
                                                          }
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.terms_and_conditions_title
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                        ,\n                         "
                                                ),
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: { href: "#" },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        $event.preventDefault()
                                                        return _vm.ui__openModalByName(
                                                          {
                                                            name:
                                                              "dialog_privacy_policy"
                                                          }
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.privacy_policy_title
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(
                                                  " \n                        and\n                         "
                                                ),
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: { href: "#" },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        $event.preventDefault()
                                                        return _vm.ui__openModalByName(
                                                          {
                                                            name:
                                                              "dialog_cancelation_policy"
                                                          }
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.cancellation_policy_title
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    "v-checkbox",
                                    bind,
                                    false
                                  ),
                                  on
                                )
                              )
                            : _vm._e()
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _vm._v(" "),
            ((_vm.is_prepay &&
              (_vm.prepay_payment || _vm.only_save_card_at_prepay)) ||
              (_vm.is_seasonal &&
                !_vm.advance_seasonal &&
                (_vm.full_charge_at_seasonal_kiosk ||
                  _vm.credit_card_swipe_kiosk)) ||
              (_vm.is_seasonal &&
                _vm.advance_seasonal &&
                (_vm.full_charge_at_seasonal_advance_on ||
                  _vm.save_card_at_seasonal_advance_on)) ||
              (!_vm.is_seasonal &&
                (_vm.full_charge_at_kiosk || _vm.swipeMode))) &&
            !_vm.cost.free_checkout
              ? [
                  _vm.$store.state.resources.config.google_recaptcha == "1" &&
                  _vm.$store.state.resources.config.google_recaptcha_site_key !=
                    ""
                    ? [
                        _c("div", { staticClass: "mt-5" }, [
                          _c("h6", [
                            _vm._v("This site is protected by Google reCAPTCHA")
                          ])
                        ])
                      ]
                    : _vm._e()
                ]
              : _vm._e(),
            _vm._v(" "),
            [
              _vm.$store.state.resources.config.google_recaptcha == "1" &&
              _vm.$store.state.resources.config.google_recaptcha_site_key != ""
                ? [
                    _c("div", { staticClass: "mt-5" }, [
                      _c("div", { ref: "kiosk_recaptcha" })
                    ])
                  ]
                : _vm._e()
            ],
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-5" },
              [
                _c("errors-alert", { attrs: { errors: _vm.v__getErrors() } }),
                _vm._v(" "),
                typeof _vm.errorMessagesList !== "undefined" &&
                typeof _vm.errorMessagesList === "object" &&
                  _vm.errorMessagesList.length !== 0 &&
                  _vm.v__getErrors().length === 0
                  ? _c("errors-alert", {
                      attrs: { errors: _vm.errorMessagesList }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "secondary",
                      disabled: _vm.$store.state.config.stepLoading
                    },
                    on: {
                      click: function($event) {
                        return _vm.go_back()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                " + _vm._s("Back") + "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      id: "card-button",
                      color: "primary",
                      loading: _vm.$store.state.config.stepLoading,
                      disabled: _vm.disabled_status
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.payButtonText()) +
                        "\n            "
                    )
                  ]
                )
              ],
              1
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "500px" },
          model: {
            value: _vm.messageDialog.show,
            callback: function($$v) {
              _vm.$set(_vm.messageDialog, "show", $$v)
            },
            expression: "messageDialog.show"
          }
        },
        [
          _c("message-modal", {
            attrs: {
              message: _vm.messageDialog.message,
              success: _vm.messageDialog.success
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }